import React, { useState, useContext } from "react";
import styled from "styled-components";
import colors from "../../utils/style/colors.tsx";
import { SousTitre, MiniTexte, PetitTexte } from "../../utils/style/elements.tsx";
import IconGame from "../../assets/images/icons/svgGame.svg";
import IconCode from "../../assets/images/icons/svgCode.svg";
import IconPro from "../../assets/images/icons/svgPro.svg";
import { HashLink } from "react-router-hash-link";
import { LanguageContext } from "../../context/LanguageContext";
import navTrad from "../../traductions/nav-trad.js";

const MainNav = styled.nav`
    z-index: 10;

    @media (min-width: 768px) {
        display: none;
    }
`;

const ToggleButton = styled.div`
    color: ${colors.white};
    min-width: 26px;
    height: 30px;
    background-color: ${colors.black};
    position: fixed;
    top: 240px;
    left: ${({ $isOpen }) => ($isOpen ? "112px" : "0px")}; /* Déplacement */
    font-weight: 700;
    cursor: pointer;
    z-index: 3;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: left 0.3s ease-in-out;
`;


const NavAccueilWrapperMobileOpen = styled.div`
    background: ${colors.white};
    color: ${colors.white};
    width: 100px;
    height: 100vh;
    top: -18px;
    left: 0;
    position: fixed;
    z-index: 2;
    transition: transform 0.3s ease-in-out;
    transform: ${({ $isOpen }) => ($isOpen ? "translateX(0)" : "translateX(-100%)")};
    border: solid 10px ${colors.black};
`;

const MenuOpenTitre = styled.div`
    padding: 8px;
    padding-top: 15px;
    background-color: ${colors.black};
`;

const MenuOpenContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 50vh;
`


const StyledHashLink = styled(HashLink)`
    color: ${colors.red};
    text-decoration: none;
    font-size: 20px;
    display: flex;
    transition: all 0.5s ease;
    font-weight: 600;
    align-items: center;
    flex-direction: column;
    margin-top: 10px;

    p {
        margin: 0;
    }
`;

const StyledMiniTexte = styled(MiniTexte)`
    color: ${colors.red};
    text-align: center;
    font-size: 12px;
`;

const StyledSousTitre = styled(SousTitre)`
    text-align: center;
`

const IconNav = styled.img`
    padding: 2px;
`;



const MenuOpenLinks = styled.div`
    gap: 10px;
    display: flex;
    flex-direction: column;
`

const MenuOpenCv = styled.div`
    display: flex;
    justify-content: center;
`

const DownloadLink = styled.a`
    border: none;
    background-color: ${colors.red};
    color: white;
    font-weight: 500;
    padding: 5px;
    padding-top: 0;
    padding-bottom: 0;
    cursor: pointer;
    position: absolute;
    bottom: 5px;
    text-decoration: none;
    text-align: center;
`;



const GrayOverlay = styled.div`
    position: fixed;
    top: 0;
    background-color: ${colors.black};
    width: 100%;
    height: 100vh;
    z-index: 1;
    opacity: ${({ $isOpen }) => ($isOpen ? "0.3" : "0")};
    transition: opacity 0.3s ease-in-out;
    pointer-events: ${({ $isOpen }) => ($isOpen ? "auto" : "none")};

    @media (min-width: 768px) {
        display: none;
    }
`;



function NavMobile() {
    const [isOpen, setIsOpen] = useState(false);
    const { language } = useContext(LanguageContext);

    // Sélection du bon fichier en fonction de la langue
    const cvFile =
    language === "en"
        ? "/pdf/CV_Anglais_Alexandre_Kotowicz_2025.pdf"
        : "/pdf/CV_Alexandre_Kotowicz_2024.pdf";

        
    return (
        <>
            <GrayOverlay $isOpen={isOpen} onClick={() => setIsOpen(false)} />
            <MainNav>
                <ToggleButton $isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? "<" : ">"}
                </ToggleButton>
                <NavAccueilWrapperMobileOpen $isOpen={isOpen}>
                    <MenuOpenTitre>
                        <StyledSousTitre>{navTrad[language].titre}</StyledSousTitre>
                    </MenuOpenTitre>
                    <MenuOpenContent>
                        <MenuOpenLinks>
                            <StyledHashLink smooth to="/#games" onClick={() => setIsOpen(!isOpen)}>
                                <IconNav src={IconGame} alt="Game Icon" width="20px" height="15px" />
                                <StyledMiniTexte>{navTrad[language].games}</StyledMiniTexte>
                            </StyledHashLink>

                            <StyledHashLink smooth to="/#pros" onClick={() => setIsOpen(!isOpen)}>
                                <IconNav src={IconPro} alt="Pro Icon" width="20px" height="17px" />
                                <StyledMiniTexte>{navTrad[language].pro}</StyledMiniTexte>
                            </StyledHashLink>
                            
                            <StyledHashLink smooth to="/#codes" onClick={() => setIsOpen(!isOpen)}>
                                <IconNav src={IconCode} alt="Code Icon" width="20px" height="16px" />
                                <StyledMiniTexte>{navTrad[language].code}</StyledMiniTexte>
                            </StyledHashLink>
                        </MenuOpenLinks>
                        <MenuOpenCv>
                            <DownloadLink href={cvFile} download>
                                <PetitTexte>{navTrad[language].bouton}</PetitTexte>
                            </DownloadLink>
                        </MenuOpenCv>
                    </MenuOpenContent>
                </NavAccueilWrapperMobileOpen>
            </MainNav>
        </>
    );
}

export default NavMobile;
